<template>
  <div class="w-100p">
    <div class="t-xl bold m-bx1">{{ props.title }}</div>
    <slot>
      <div class="t dark-gray">{{ props.description }}</div>
    </slot>
  </div>
</template>

<script setup>
  const props = defineProps({
    title: { type: String, required: true },
    description: { type: String, default: null },
  });
</script>
